import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification } from "../../../../helpers";
import { Modal, Checkbox, Row, Col, notification as Notification, Result, Button, Input } from 'antd';

const { TextArea } = Input;

class TripApprovalDetailReason extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkedItems: [],
            message: "",
            loadings: {
                submit: false
            },
            isSuccess: false
        };
    }

    componentWillMount() {
    }


    onChangeCheckBox = (item) => {
        let { checkedItems } = this.state;

        if (checkedItems.some(e => e.id === item.id)) {
            checkedItems = checkedItems.filter(x => x.id !== item.id)
        } else {
            checkedItems.push(item)
        }

        this.setState({ checkedItems })

    }

    onChangeTextArea = (e) => {
        this.setState({ message: e.target.value })
    }

    fetch = () => {

        let endpoint = { keyOne: "trip", idOne: this.props.id, keyTwo: "vendortripcostresponse" };

        let { loadings, checkedItems, message } = this.state;

        loadings.submit = true;
        this.setState({ loadings });

        let reasonIds = [];

        checkedItems.forEach((item) => {
            reasonIds.push(item.id)
        })

        this.props
            .dispatch(
                actions.definitions.addData({
                    ...endpoint,
                    data: {
                        id: this.props.id,
                        objectionReasonIds: reasonIds,
                        objectionReasonText: message

                    },
                })
            )
            .then(() => {
                loadings.submit = false;

                this.setState({
                    loadings, isSuccess: true
                });
                this.props.onSuccess()

            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };


    render() {

        const { handleToggle, isModalOpen, warningMessage, reasons, cost } = this.props;
        let { checkedItems, loadings, isSuccess, message } = this.state

        // let isTextArea = false;

        // if (cost.isDistanceControl || cost.isPointControl) {
        //     isTextArea = true;
        // }

        let isApproveButtonDisable = true;

        if(checkedItems.length === 0 || message.length <= 0){
            isApproveButtonDisable = true;
        }else {
            isApproveButtonDisable = false;
        }

        return (

            <Modal
                className='approval-ok-modal'
                title="İtiraz Sebebi" centered
                open={isModalOpen}
                onOk={() => !isSuccess ? this.fetch() : handleToggle}
                onCancel={handleToggle}
                maskClosable={false}
                destroyOnClose={true}
                width={760}
                footer={[
                    !isSuccess &&
                    <Button onClick={handleToggle}>
                        İptal
                    </Button>,

                    !isSuccess ?
                        <Button type='primary' onClick={() => this.fetch()}
                            disabled={isApproveButtonDisable}
                            loading={loadings.submit}
                        >
                            Gönder
                        </Button >
                        :
                        <Button type='primary' onClick={handleToggle}
                        >
                            Kapat
                        </Button >


                ]}
            >

                {
                    isSuccess &&
                    <Result
                        status="success"
                        title="Bu talebi reddettiniz"
                    />
                }

                {
                    !isSuccess &&
                    <Fragment>

                        <Row>
                            <Col>
                                <div className='warning mb-10'>{warningMessage}</div>
                            </Col>
                        </Row>

                        {
                            cost.isDistanceControl &&
                            <Row>
                                <Col>
                                    <div className='warning mb-10'>{cost.distanceControlMessage}</div>
                                </Col>
                            </Row>
                        }
                        {
                            cost.isPointControl &&
                            <Row>
                                <Col>
                                    <div className='warning mb-10'>{cost.pointControlMessage}</div>
                                </Col>
                            </Row>
                        }

                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                {
                                    reasons.map((item) => {
                                        return (
                                            <div key={item.id}>

                                                <Checkbox key={item.id}
                                                    onChange={(e) => this.onChangeCheckBox(item)}>
                                                    {item.reasonText}
                                                </Checkbox>
                                            </div>
                                        )
                                    })
                                }

                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <TextArea rows={4} placeholder='Mesajınızı giriniz'
                                    onChange={(e) => this.onChangeTextArea(e)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className='info'>Bu alan zorunlu</div>
                            </Col>
                        </Row>
                    </Fragment>
                }


            </Modal>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripApprovalDetailReason);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripApproval/TripApprovalDetailReason.js